var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"is-primary btn-add-item",class:{'is-outlined': _vm.isOutlined},on:{"click":function($event){return _vm.showAddItemModal()}}},[_c('plus-icon',{attrs:{"size":"1.5x"}}),_vm._v(" "+_vm._s(_vm.$t('dict.addAnItem'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }